import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type {
  ReportDashboardLibraryComponent,
  ReportDashboardLibraryApiResponse,
} from '@core/reports-types';

@Injectable({ providedIn: 'root' })
export class ReportsLibraryComponentsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  // TODO: shared analytics change endpoint without /report after backend update
  public fetchCollection(): Observable<{ componentTemplates: ReportDashboardLibraryComponent[] }> {
    return this.httpApi.get<ReportDashboardLibraryApiResponse>('/report/component_templates');
  }
}
